import { Component, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToastrService } from '@shared-angular/services/toastr.service';
import { SupervisorFunction } from '@shared/index';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from "primeng/button";
import { MenuModule } from 'primeng/menu';
import { TooltipModule } from 'primeng/tooltip';
import { RouteShareService } from '../../../../../../../shared/services/route-share.service';
import { SupervisorThreadBroadcastService } from '../supervisor-threads/supervisor-thread-broadcast.service';
import { SupervisorService } from '../supervisor.service';

@Component({
  selector: 'app-supervisor-function-exec',
  imports: [FormsModule, MenuModule, ButtonModule, TooltipModule],
  templateUrl: './supervisor-function-exec.component.html',
  styleUrl: './supervisor-function-exec.component.scss'
})
export class SupervisorFunctionExecComponent {
  public readonly disabled = input<boolean>(true);
  public menuItems: MenuItem[] = [];

  constructor(public supervisorService: SupervisorService, public rss: RouteShareService, public toastr: ToastrService, public threadBroadcastService: SupervisorThreadBroadcastService) {
  }

  public buildMenuItems(): void {
    this.menuItems = this.rss.botConfig.supervisorFunctions.map(s => ({
      label: s.name,
      command: () => { this.triggerFn(s); }
    }));
  }

  public triggerFn(f: SupervisorFunction): void {
    const count = this.threadBroadcastService.selectedThreadsSet.size;
    if (count == 0) {
      void this.supervisorService.triggerSupervisorfunction(f);
      this.toastr.success("GENERAL", $localize`:@@fn-triggered-one:\u201E${f.name}\u201C wurde ausgef\u00fchrt.`);
    } else {
      const activeCount = Array.from(this.threadBroadcastService.selectedThreadsSet)
        .filter(t => this.supervisorService.isThreadActive(t)).length;
      this.threadBroadcastService.broadcastSupervisorFunction(f);
      this.toastr.success("GENERAL", $localize`:@@fn-triggered-many:\u201E${f.name}\u201C wurde an ${activeCount} Online-Chats gesendet.`);
    }
  }
}
